import { queryOptions } from '@tanstack/react-query';

import { api } from '@/lib/api/api';
import type { EntityListParams } from '@/lib/api/domains/entities';
import type { EntityId } from '@/lib/api/ids';
import { keys } from '@/lib/query-keys';

/*
 * Consumption layer for organizations (E02.F04). queryOptions say how this UI
 * reads the `/entities` transport — keys and a short stale time (entity setup
 * is edited by a small team during the cutover, so a stale read is cheap to
 * refresh). The detail read carries the organization's relationships in both
 * directions (R11); the server decides each relationship's in-force flag
 * against the work's business date — the FE never computes it.
 */

export function entityListQuery(params: EntityListParams) {
  return queryOptions({
    queryKey: keys.entities.list(params),
    queryFn: () => api.entities.list(params),
    staleTime: 15_000,
  });
}

export function entityDetailQuery(entityId: EntityId) {
  return queryOptions({
    queryKey: keys.entities.detail(entityId),
    queryFn: () => api.entities.get(entityId),
    staleTime: 15_000,
  });
}
